// extracted by mini-css-extract-plugin
export default {"onsiteInfo":"InfoTooltip_onsiteInfo__5wN1j","onsiteInfoTooltiptext":"InfoTooltip_onsiteInfoTooltiptext__Hs0aJ"};